import React from 'react'
import { Modal } from 'react-bootstrap'
import Rep_stock_valuation from './reports/financial/Rep_stock_valuation'

function Stock_valuation_model(props) {
    return (
        <div>
            <Modal show={props.showStockValuation} size='xl' onHide={() => props.setShowStockValuation(false)} scrollable backdrop="static">
                <Modal.Header closeButton>
                    <h4>Stock Valuation</h4>
                </Modal.Header>
                <Modal.Body>
                    <Rep_stock_valuation hideLoginHeader={true} />
                </Modal.Body>
            </Modal>
        </div>
    )
}

export default Stock_valuation_model
